<template>
    <div class="web" :style="{height:screenHeight + 'px'}">
       <div class="web-box">
            <div class="web-text">
                <div class="web-title">
                    <span>{{date.Maintitle}}</span>
                </div>
                <div class="web-subtitle">
                    <span>{{date.Subtitle}}</span>
                </div>
                <div class="web-line"></div>
                <div class="web-content">
                    <div v-html="date.PContent"></div>
                </div>
            </div>
            <div class="web-banner">
                <video :style="{Height:Height+'px'}" :src="date.PImage" controls = "true" autoplay></video>
            </div>
       </div>
    </div>
</template>
<script>
    import { ShowPortalInfo } from "../api/home.js";
    export default {
        name: "web",
        data(){
            return{
                screenHeight: document.documentElement.clientHeight-120,
                Height: ((document.documentElement.clientHeight-120)*0.8)+'px',
                date:{},
            }
        },
        mounted(){
            this.Info()
        },
        methods:{
            Info(){
                let params=`pType=e葩钻`
                ShowPortalInfo(params).then(res=>{
                    this.date = res.Data[0]
                })
            },
        },
    }
</script>
<style scoped lang="scss">
    .web {
        overflow: hidden;
        width: 100%;
        &-box{
            background-image: url('../assets/img/meigui.png');
            background-size: 80%;
            background-repeat: no-repeat;
            background-position: 50%;
            width: 1103px;
            margin: 0 auto;
            height: 100%;
            display: flex;
        }
        
        &-text{
            width: 50%;
            height: 100%;
        }
        &-banner{
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            video{
                width: 345px;
            }
        }
        &-title{
            font-size: 45px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #2A2A3E;
            margin-top: 20%;
        }
        &-subtitle{
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4F4F6C;
            margin-top: 20px;
        }
        &-line{
            margin-top: 50px;
            width: 80px;
            height: 5px;
            background: #0505AE;
            border-radius: 5px;
        }
        &-content{
            margin-top: 50px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000;
            letter-spacing: 2px;
            font-family: '微软雅黑';
            text-indent:2em;
        }
    }
    .web::-webkit-scrollbar { width: 0 !important }
    .web { -ms-overflow-style: none; }
    .web { overflow: -moz-scrollbars-none; }
</style>